import { getApiName } from '../../convert-api-result-to-google-json/index.js';
import { getDocsFromResponse, fillAddressFromDoc } from '../utils/index.js';
export function createDropdown( context ) {
	const { field, dropdownClassname, suggestList, dropdownEventHandler } =
		context;
	const dropdownExsists = field.parentNode.querySelector(
		`.${ dropdownClassname }`
	);
	if ( dropdownExsists ) {
		return;
	}
	const dropdownDiv = document.createElement( 'div' );
	dropdownDiv.className = dropdownClassname;
	dropdownDiv.innerHTML = suggestList;
	// Step 7.2 - create event listener for newly created dropdown
	dropdownDiv.addEventListener( 'click', dropdownEventHandler );
	field.parentNode.insertBefore( dropdownDiv, field.nextSibling );
}

export function updateDropdown( context ) {
	const { field, dropdownClassname, suggestList } = context;
	const dropdown = field.parentNode.querySelector(
		`.${ dropdownClassname }`
	);
	if ( ! dropdown ) return;
	dropdown.innerHTML = '';
	dropdown.insertAdjacentHTML( 'afterbegin', suggestList );
	field._activeIndex = -1;
	field.removeAttribute( 'aria-activedescendant' );
}

export function showDropdown( context ) {
	const { field, dropdownClassname } = context;
	const dropdown = field.parentNode.querySelector(
		`.${ dropdownClassname }`
	);
	if ( ! dropdown ) return;
	dropdown.style.display = 'block';
	field.setAttribute( 'aria-expanded', 'true' );
}

export function hideDropdown( context ) {
	const { field, dropdownClassname } = context;
	if (
		field._debouncedHandler &&
		typeof field._debouncedHandler.cancel === 'function'
	) {
		field._debouncedHandler.cancel();
	}
	const dropdown = field.parentNode.querySelector(
		`.${ dropdownClassname }`
	);
	if ( ! dropdown ) return;
	dropdown.style.display = 'none';
	field.setAttribute( 'aria-expanded', 'false' );
	field._activeIndex = -1;
	field.removeAttribute( 'aria-activedescendant' );
}


// Step 10 - Handle clicks on dropdown address items
export function dropdownClickHandler( context ) {
	const { apiLookupUrl, apiRequest, dropdownClassname, apiLookupIdParam } =
		context;
	return async function ( event ) {
		if ( ! event.target || event.target.nodeName !== 'LI' ) return;
		const addressId = event.target.getAttribute( 'data-id' );
		if ( ! addressId ) return;

		// Step 11 - Based on id, fetch address long lat from the api
		// Example PDOK api Url:
		// https://api.pdok.nl/bzk/locatieserver/search/v3_1/lookup?id=adr-fdb2e010d3f6ca2fc6cc7952ca085985
		const lookupUrl = `${ apiLookupUrl }?${ apiLookupIdParam }${ addressId }`;
		const results = await apiRequest( lookupUrl );
		const docs = getDocsFromResponse( results );
		if ( docs.length === 0 ) return;
		const doc = docs[ 0 ];

		// Step 12 - Gracefully close dropdown and update map pin
		const dropdownElem = event.target.closest( `.${ dropdownClassname }` );
		if ( ! dropdownElem ) return;
		hideDropdown( { ...context, field: dropdownElem } );

		// Step 13 - Fill address input and update map pin
		const closestInput = dropdownElem.previousElementSibling;
		if ( closestInput ) {
			fillAddressFromDoc( closestInput, doc );
		}
	};
}

export function createSuggestList( data ) {
	const docs = getDocsFromResponse( data );

	if ( ! Array.isArray( docs ) || docs.length === 0 ) {
		return '<ul role="listbox"></ul>';
	}
	const translatedAddress = getApiName( 'address', 'pdok' );
	return `<ul role="listbox">${ docs
		.map(
			( doc, index ) =>
				`<li role="option" id="acf-address-option-${ index }" tabindex="-1" data-id='${ doc.id }'>${ doc[ translatedAddress ] }</li>`
		)
		.join( '' ) }</ul>`;
}
